export var defaultMagazine = {
  id: process.env.REACT_APP_CLIENT_ID || ""
};